import cn from 'classnames'
import s from '@corratech/air-ooka-header/Navbar/Navbar.module.scss'
import { RichContent } from '@corratech/pylot-rich-content'
import { Menu } from '../Menu/Menu'
import { UserNav } from './../UserNav/UserNav'
import { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import { usePreloadedData } from '@preload'
import Link from '@corratech/pylot-ui/src/Link'
// @ts-ignore
import LogoWhite from 'stores/ooka_default/components/icons/LogoWhite.tsx'
import { useTranslation } from 'next-i18next'
import { CmsBlock } from '@pylot-data/fwrdschema'
import { useRouter } from 'next/router'
import { CustomKitBackButton } from '@corratech/air-ooka-header/CustomKitBackButton/CustomKitBackButton'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { useCmsBlocks } from '@pylot-data/hooks/cms/use-cms-blocks'

type NavbarProps = {
    isMobileMenuOpened: boolean
    setIsMobileMenuOpened: Dispatch<SetStateAction<boolean>>
}

type CmsBlocksResponse = {
    data: {
        cmsBlocks: {
            items: CmsBlock[] | [null]
        }
    }
}
export const Navbar = ({
    isMobileMenuOpened,
    setIsMobileMenuOpened
}: NavbarProps) => {
    const initialData = (usePreloadedData(
        'header'
    ) as unknown) as CmsBlocksResponse
    const config = useStoreConfig()
    const { header: { variables } = {} } = config.preload
    const { items } = useCmsBlocks(variables?.identifiers ?? [], {
        initialData,
        revalidateOnMount: true,
        revalidateOnFocus: false
    })
    const { t } = useTranslation('common')
    const headerRef = useRef<HTMLDivElement | null>(null)
    const router = useRouter()
    const isCustomkit = router.query.option === 'customize'
    const isCheckout = router.pathname?.includes('/checkout')

    useEffect(() => {
        if (headerRef?.current && isMobileMenuOpened) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [isMobileMenuOpened])

    useEffect(() => {
        if (isMobileMenuOpened && headerRef.current) {
            headerRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
        }
    }, [isMobileMenuOpened, router.asPath])

    const renderLogoAndNavigation = () => (
        <Link href="/">
            <span className={cn(s.logo, 'logo')} aria-label={t('Logo')}>
                <LogoWhite />
            </span>
        </Link>
    )

    const renderMobileBurger = () => {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <button
                className={cn(
                    s.burgerIconMain,
                    isMobileMenuOpened && s.burgerIconMainClose,
                    'headerBurgerIcon'
                )}
                onClick={() => {
                    setIsMobileMenuOpened(!isMobileMenuOpened)
                }}
            >
                <div className={s.burgerIconContent} />
            </button>
        )
    }

    return (
        <>
            {items?.length && items[1] && (
                <div className="legalTopBanner">
                    <RichContent html={items[1]?.content} />
                </div>
            )}
            <div
                className={cn(
                    s['NavBarWrapper'],
                    isCustomkit && s.isCustomkit,
                    isCheckout && s.isCheckout
                )}
                ref={headerRef}
            >
                <div className={cn(s.navbarPromo, 'navbarPromo')}>
                    {items && items.length && (
                        <RichContent html={items[0]?.content} />
                    )}
                </div>
                <div className={s['headerMain']}>
                    <div className={s['headerMainWrapper']}>
                        {isCustomkit && <CustomKitBackButton />}
                        <div className={s['BurgerAndLogo']}>
                            {renderMobileBurger()}
                            {renderLogoAndNavigation()}
                        </div>
                        <Menu
                            isMobileMenuOpened={isMobileMenuOpened}
                            setIsMobileMenuOpened={setIsMobileMenuOpened}
                        />
                        <UserNav />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Navbar
